const statusMessages = {
	ajaxError: 'Some error occured!',
	invalidRequest: 'Invalid Request',
	loginSuccess: 'Login Success!',
	loginError: 'Invalid Credentials!',
	logoutSuccess: 'Logout Success!',
	forgotPasswordSuccess: 'Reset Password link sent to email',
	resetPasswordSuccess: 'Successfully updated password',
	resetPasswordError: 'Error updating password!',
	passwordsMismatch: 'Passwords mismatch!',
	samePasswordsError: 'Old & New Passwords should not be same!',
	insertError: 'Error saving data',
	updateError: 'Error updating data',
	deleteError: 'Error deleting data',
	insertSuccess: 'Data saved successfully',
	updateSuccess: 'Data updated successfully',
	deleteSuccess: 'Data deleted successfully',
	emptyInvoiceItems: 'Could not save invoice. Invoice Items is empty',
	emptyInvoiceCustomer: 'Could not save invoice. Customer is not selected',
	emptyInvoiceFranchisee: 'Could not save invoice. Franchisee is not selected',
	invalidInvoiceTotal: 'Could not save invoice. Total Amount should be valid',
	insertInvoiceSuccess: 'Invoice Saved Successfully',
	updateInvoiceSuccess: 'Invoice Updated Successfully',
	emptyPurchaseItems: 'Could not save purchase. Purchase Items is empty',
	invalidPurchaseTotal: 'Could not save purchase. Total Amount should be valid',
	invalidPurchaseItems: 'Could not save purchase. Invalid Item Quantity or Rate',
	insertPurchaseSuccess: 'Purchase Saved Successfully',
	updatePurchaseSuccess: 'Purchase Updated Successfully',
	emptyProductionItems: 'Could not save production. Items is empty',
	emptyProductionMaterials: 'Could not save production. Raw Materials is empty',
	insertProductionSuccess: 'Production Saved Successfully',
	updateProductionSuccess: 'Production Updated Successfully',
	emptyStockDispatchItems: 'Items are empty',
	emptyStockDispatchWarehouse: 'Warehouse is not selected',
	emptyStockDispatchFactory: 'Factory is not selected',
	insertStockDispatchSuccess: 'Stock Dispatch Saved Successfully',
	updateStockDispatchSuccess: 'Stock Dispatch Updated Successfully',
	emptyStockMovementItems: 'Items are empty',
	emptyStockMovementWarehouse: 'Warehouse is not selected',
	insertStockMovementSuccess: 'Stock Movement Saved Successfully',
	updateStockMovementSuccess: 'Stock Movement Updated Successfully',
	emptySalesReturnItems: 'Could not save Sale Return. Return Items should not be empty',
	salesReturnItemsCountZero: 'Could not save Sale Return. Return Items count should not be zero',
	insertSalesReturnSuccess: 'Sale Return Saved Successfully',
	updateSalesReturnSuccess: 'Sale Return updated Successfully',
	emptyPurchaseReturnItems: 'Could not save Purchase Return. Return Items should not be empty',
	purchaseReturnItemsCountZero: 'Could not save Purchase Return. Return Items count should not be zero',
	insertPurchaseReturnSuccess: 'Purchase Return Saved Successfully',
	updatePurchaseReturnSuccess: 'Purchase Return updated Successfully',
}

export default statusMessages
